/* This file was generated by the generate-icons.ts script */

export const cmsIcons = {
  "AI": {
    "iconName": "AI_Icon",
    "title": "AI"
  },
  "App-Phone": {
    "iconName": "App-Phone_Icon",
    "title": "App Phone"
  },
  "Apple": {
    "iconName": "Apple_Icon",
    "title": "Apple"
  },
  "Arrow": {
    "iconName": "Arrow_Icon",
    "title": "Arrow"
  },
  "Arrow2": {
    "iconName": "Arrow2_Icon",
    "title": "Arrow2"
  },
  "Arrow3": {
    "iconName": "Arrow3_Icon",
    "title": "Arrow3"
  },
  "Badge": {
    "iconName": "Badge_Icon",
    "title": "Badge"
  },
  "Bag": {
    "iconName": "Bag_Icon",
    "title": "Bag"
  },
  "Bag-with-food": {
    "iconName": "Bag-with-food_Icon",
    "title": "Bag with food"
  },
  "Bell": {
    "iconName": "Bell_Icon",
    "title": "Bell"
  },
  "Book": {
    "iconName": "Book_Icon",
    "title": "Book"
  },
  "Bread": {
    "iconName": "Bread_Icon",
    "title": "Bread"
  },
  "Bread2": {
    "iconName": "Bread2_Icon",
    "title": "Bread2"
  },
  "Briefcase": {
    "iconName": "Briefcase_Icon",
    "title": "Briefcase"
  },
  "Burger": {
    "iconName": "Burger_Icon",
    "title": "Burger"
  },
  "CO2": {
    "iconName": "CO2_Icon",
    "title": "CO2"
  },
  "CO2e": {
    "iconName": "CO2e_Icon",
    "title": "CO2e"
  },
  "Calendar": {
    "iconName": "Calendar_Icon",
    "title": "Calendar"
  },
  "Calendar-Day": {
    "iconName": "Calendar-Day_Icon",
    "title": "Calendar Day"
  },
  "Calendar-Month": {
    "iconName": "Calendar-Month_Icon",
    "title": "Calendar Month"
  },
  "Cap": {
    "iconName": "Cap_Icon",
    "title": "Cap"
  },
  "Carrot": {
    "iconName": "Carrot_Icon",
    "title": "Carrot"
  },
  "Chat": {
    "iconName": "Chat_Icon",
    "title": "Chat"
  },
  "Cherry": {
    "iconName": "Cherry_Icon",
    "title": "Cherry"
  },
  "Chicken": {
    "iconName": "Chicken_Icon",
    "title": "Chicken"
  },
  "Clock": {
    "iconName": "Clock_Icon",
    "title": "Clock"
  },
  "Cloud": {
    "iconName": "Cloud_Icon",
    "title": "Cloud"
  },
  "Coins": {
    "iconName": "Coins_Icon",
    "title": "Coins"
  },
  "Compass": {
    "iconName": "Compass_Icon",
    "title": "Compass"
  },
  "Consumer_Marketplace": {
    "iconName": "Consumer_Marketplace_Icon",
    "title": "Consumer Marketplace"
  },
  "Croissant": {
    "iconName": "Croissant_Icon",
    "title": "Croissant"
  },
  "Cross": {
    "iconName": "Cross_Icon",
    "title": "Cross"
  },
  "Crown": {
    "iconName": "Crown",
    "title": "Crown"
  },
  "Curved-Long": {
    "iconName": "Curved-Long_Icon",
    "title": "Curved Long"
  },
  "Curved-Short": {
    "iconName": "Curved-Short_Icon",
    "title": "Curved Short"
  },
  "Cutlery": {
    "iconName": "Cutlery_Icon",
    "title": "Cutlery"
  },
  "Dollar-Bill": {
    "iconName": "Dollar-Bill_Icon",
    "title": "Dollar Bill"
  },
  "Donations": {
    "iconName": "Donations_Icon",
    "title": "Donations"
  },
  "Download": {
    "iconName": "Download_Icon",
    "title": "Download"
  },
  "Earth": {
    "iconName": "Earth_Icon",
    "title": "Earth"
  },
  "Earth2": {
    "iconName": "Earth2_Icon",
    "title": "Earth2"
  },
  "Electricity": {
    "iconName": "Electricity_Icon",
    "title": "Electricity"
  },
  "Empty_State": {
    "iconName": "Empty_State_Icon",
    "title": "Empty State"
  },
  "Euro-Bill": {
    "iconName": "Euro-Bill_Icon",
    "title": "Euro Bill"
  },
  "Expiry_Date_Management": {
    "iconName": "Expiry_Date_Management_Icon",
    "title": "Expiry Date Management"
  },
  "Facebook": {
    "iconName": "Facebook_Icon",
    "title": "Facebook"
  },
  "Functionally-Diverse": {
    "iconName": "Functionally-Diverse_Icon",
    "title": "Functionally Diverse"
  },
  "Garlic": {
    "iconName": "Garlic_Icon",
    "title": "Garlic"
  },
  "Gift": {
    "iconName": "Gift_Icon",
    "title": "Gift"
  },
  "Hand-Earth": {
    "iconName": "Hand-Earth_Icon",
    "title": "Hand Earth"
  },
  "Hand-Heart": {
    "iconName": "Hand-Heart_Icon",
    "title": "Hand Heart"
  },
  "Hand-Sprout": {
    "iconName": "Hand-Sprout_Icon",
    "title": "Hand Sprout"
  },
  "Happy": {
    "iconName": "Happy_Icon",
    "title": "Happy"
  },
  "Heart": {
    "iconName": "Heart_Icon",
    "title": "Heart"
  },
  "Heart-Eyes": {
    "iconName": "Heart-Eyes_Icon",
    "title": "Heart Eyes"
  },
  "Highfive": {
    "iconName": "Highfive_Icon",
    "title": "Highfive"
  },
  "HotCoffee": {
    "iconName": "HotCoffee_Icon",
    "title": "HotCoffee"
  },
  "HotTea": {
    "iconName": "HotTea_Icon",
    "title": "HotTea"
  },
  "Houses_of_Parliament": {
    "iconName": "Houses_of_Parliament_Icon",
    "title": "Houses of Parliament"
  },
  "Image": {
    "iconName": "Image_Icon",
    "title": "Image"
  },
  "Instagram": {
    "iconName": "Instagram_Icon",
    "title": "Instagram"
  },
  "Instore_Discounting": {
    "iconName": "Instore_Discounting_Icon",
    "title": "Instore Discounting"
  },
  "Intelligent_Recommendations": {
    "iconName": "Intelligent_Recommendations_Icon",
    "title": "Intelligent Recommendations"
  },
  "Key": {
    "iconName": "Key_Icon",
    "title": "Key"
  },
  "Lemon": {
    "iconName": "Lemon_Icon",
    "title": "Lemon"
  },
  "Lettuce": {
    "iconName": "Lettuce_Icon",
    "title": "Lettuce"
  },
  "Light-Bulb": {
    "iconName": "Light-Bulb_Icon",
    "title": "Light Bulb"
  },
  "Light-Bulb2": {
    "iconName": "Light-Bulb2_Icon",
    "title": "Light Bulb2"
  },
  "Link": {
    "iconName": "Link_Icon",
    "title": "Link"
  },
  "Linkedin": {
    "iconName": "Linkedin_Icon",
    "title": "Linkedin"
  },
  "List": {
    "iconName": "List_Icon",
    "title": "List"
  },
  "Location": {
    "iconName": "Location_Icon",
    "title": "Location"
  },
  "Location2": {
    "iconName": "Location2_Icon",
    "title": "Location2"
  },
  "Lock": {
    "iconName": "Lock_Icon",
    "title": "Lock"
  },
  "Look": {
    "iconName": "Look",
    "title": "Look"
  },
  "Magic-Parcel": {
    "iconName": "Magic-Parcel_Icon",
    "title": "Magic Parcel"
  },
  "Magnifying-Glass": {
    "iconName": "Magnifying-Glass_Icon",
    "title": "Magnifying Glass"
  },
  "Magnifying_Glass2": {
    "iconName": "Magnifying_Glass2_Icon",
    "title": "Magnifying Glass2"
  },
  "Mail": {
    "iconName": "Mail_Icon",
    "title": "Mail"
  },
  "Map": {
    "iconName": "Map_Icon",
    "title": "Map"
  },
  "Megaphone": {
    "iconName": "Megaphone_Icon",
    "title": "Megaphone"
  },
  "Meh": {
    "iconName": "Meh_Icon",
    "title": "Meh"
  },
  "Messenger": {
    "iconName": "Messenger_Icon",
    "title": "Messenger"
  },
  "Money-dollar": {
    "iconName": "Money-dollar_Icon",
    "title": "Money dollar"
  },
  "Money-euro": {
    "iconName": "Money-euro_Icon",
    "title": "Money euro"
  },
  "Money-pound": {
    "iconName": "Money-pound_Icon",
    "title": "Money pound"
  },
  "Music": {
    "iconName": "Music_Icon",
    "title": "Music"
  },
  "Notification": {
    "iconName": "Notification_Icon",
    "title": "Notification"
  },
  "Number-1": {
    "iconName": "Number-1_Icon",
    "title": "Number 1"
  },
  "Number-2": {
    "iconName": "Number-2_Icon",
    "title": "Number 2"
  },
  "Number-3": {
    "iconName": "Number-3_Icon",
    "title": "Number 3"
  },
  "Number-4": {
    "iconName": "Number-4_Icon",
    "title": "Number 4"
  },
  "OneThirdPie": {
    "iconName": "OneThirdPie_Icon",
    "title": "OneThirdPie"
  },
  "Orange": {
    "iconName": "Orange_Icon",
    "title": "Orange"
  },
  "POC": {
    "iconName": "POC_Icon",
    "title": "POC"
  },
  "PPuzzle": {
    "iconName": "PPuzzle",
    "title": "PPuzzle"
  },
  "Paper-Plane": {
    "iconName": "Paper-Plane_Icon",
    "title": "Paper Plane"
  },
  "Paperwork": {
    "iconName": "Paperwork_Icon",
    "title": "Paperwork"
  },
  "Parcel": {
    "iconName": "Parcel_Icon",
    "title": "Parcel"
  },
  "Pear": {
    "iconName": "Pear_Icon",
    "title": "Pear"
  },
  "People": {
    "iconName": "People",
    "title": "People"
  },
  "Pepper": {
    "iconName": "Pepper_Icon",
    "title": "Pepper"
  },
  "Pizza": {
    "iconName": "Pizza_Icon",
    "title": "Pizza"
  },
  "Pound-Bill": {
    "iconName": "Pound-Bill_Icon",
    "title": "Pound Bill"
  },
  "Price-Tag": {
    "iconName": "Price-Tag_Icon",
    "title": "Price Tag"
  },
  "Pride": {
    "iconName": "Pride_Icon",
    "title": "Pride"
  },
  "Product": {
    "iconName": "Product_Icon",
    "title": "Product"
  },
  "Question": {
    "iconName": "Question_Icon",
    "title": "Question"
  },
  "Receipt": {
    "iconName": "Receipt_Icon",
    "title": "Receipt"
  },
  "Recycle": {
    "iconName": "Recycle_Icon",
    "title": "Recycle"
  },
  "Rice-bowl": {
    "iconName": "Rice-bowl_Icon",
    "title": "Rice bowl"
  },
  "Rocket": {
    "iconName": "Rocket",
    "title": "Rocket"
  },
  "Round-Corner": {
    "iconName": "Round-Corner_Icon",
    "title": "Round Corner"
  },
  "Sad": {
    "iconName": "Sad_Icon",
    "title": "Sad"
  },
  "Salesforce": {
    "iconName": "Salesforce_Icon",
    "title": "Salesforce"
  },
  "Schedule": {
    "iconName": "Schedule_Icon",
    "title": "Schedule"
  },
  "Screw": {
    "iconName": "Screw_Icon",
    "title": "Screw"
  },
  "Settings": {
    "iconName": "Settings_Icon",
    "title": "Settings"
  },
  "Share": {
    "iconName": "Share_Icon",
    "title": "Share"
  },
  "Share2": {
    "iconName": "Share2_Icon",
    "title": "Share2"
  },
  "Shopping-Cart": {
    "iconName": "Shopping-Cart_Icon",
    "title": "Shopping Cart"
  },
  "Shower": {
    "iconName": "Shower_Icon",
    "title": "Shower"
  },
  "Smartphone": {
    "iconName": "Smartphone_Icon",
    "title": "Smartphone"
  },
  "Smell": {
    "iconName": "Smell",
    "title": "Smell"
  },
  "Smug": {
    "iconName": "Smug_Icon",
    "title": "Smug"
  },
  "Snapchat": {
    "iconName": "Snapchat_Icon",
    "title": "Snapchat"
  },
  "Sound-Off": {
    "iconName": "Sound-Off_Icon",
    "title": "Sound Off"
  },
  "Sound-On": {
    "iconName": "Sound-On_Icon",
    "title": "Sound On"
  },
  "Spaghetti": {
    "iconName": "Spaghetti_Icon",
    "title": "Spaghetti"
  },
  "Star": {
    "iconName": "Star_Icon",
    "title": "Star"
  },
  "Star2": {
    "iconName": "Star2_Icon",
    "title": "Star2"
  },
  "Store": {
    "iconName": "Store_Icon",
    "title": "Store"
  },
  "Store-Clock": {
    "iconName": "Store-Clock_Icon",
    "title": "Store Clock"
  },
  "Store2": {
    "iconName": "Store2_Icon",
    "title": "Store2"
  },
  "Straight-Long": {
    "iconName": "Straight-Long_Icon",
    "title": "Straight Long"
  },
  "Straight-Small": {
    "iconName": "Straight-Small_Icon",
    "title": "Straight Small"
  },
  "Strawberry": {
    "iconName": "Strawberry_Icon",
    "title": "Strawberry"
  },
  "Sushi": {
    "iconName": "Sushi_Icon",
    "title": "Sushi"
  },
  "TGTG_Logo": {
    "iconName": "TGTG_Logo",
    "title": "TGTG Logo"
  },
  "TV": {
    "iconName": "TV_Icon",
    "title": "TV"
  },
  "Taste": {
    "iconName": "Taste",
    "title": "Taste"
  },
  "Thumbsup": {
    "iconName": "Thumbsup_Icon",
    "title": "Thumbsup"
  },
  "Tick": {
    "iconName": "Tick_Icon",
    "title": "Tick"
  },
  "Tiktok": {
    "iconName": "Tiktok_Icon",
    "title": "Tiktok"
  },
  "Tomato": {
    "iconName": "Tomato_Icon",
    "title": "Tomato"
  },
  "Tools": {
    "iconName": "Tools_Icon",
    "title": "Tools"
  },
  "Tractor": {
    "iconName": "Tractor_Icon",
    "title": "Tractor"
  },
  "Truck": {
    "iconName": "Truck_Icon",
    "title": "Truck"
  },
  "Twitter": {
    "iconName": "Twitter_Icon",
    "title": "Twitter"
  },
  "Type9": {
    "iconName": "Type9",
    "title": "Type9"
  },
  "User": {
    "iconName": "User_Icon",
    "title": "User"
  },
  "Very-Happy": {
    "iconName": "Very-Happy_Icon",
    "title": "Very Happy"
  },
  "Very-Happy2": {
    "iconName": "Very-Happy2_Icon",
    "title": "Very Happy2"
  },
  "Very-sad": {
    "iconName": "Very-sad_Icon",
    "title": "Very sad"
  },
  "Voucher": {
    "iconName": "Voucher_Icon",
    "title": "Voucher"
  },
  "Warehouse": {
    "iconName": "Warehouse_Icon",
    "title": "Warehouse"
  },
  "Water": {
    "iconName": "Water_Icon",
    "title": "Water"
  },
  "Women": {
    "iconName": "Women_Icon",
    "title": "Women"
  },
  "X_icon": {
    "iconName": "X_icon",
    "title": "X icon"
  },
  "Youtube": {
    "iconName": "Youtube_Icon",
    "title": "Youtube"
  }
} as const;
